import Page from "src/components/Report/Page";
import HeaderFactors from "./components/Factors/HeaderFactors";
import ExplainFactor from "./components/Factors/ExplainFactor";
import SpaceBetweenTables from "./components/Factors/SpaceBetweenTables";
import Table14 from "./components/Factors/Table/Table14";
import Table15 from "./components/Factors/Table/Table15";
import { useState } from "react";

const PageG5 = ({ reload }) => {
  const [azadiAmalScore, setAzadiAmalScore] = useState("")
  const [argonomi, setArgonomi] = useState("")
  return (
    <>
      <Page pageNumber={29}>
        <HeaderFactors
          numberFactors="عامل دهم"
          titelFactors="ایمنی، بهداشت، محيط زیست و ارگونومی"
          maxValue="30"
          jsValue={argonomi}
        />
        <ExplainFactor
          text="مسئولیت در قبال رعایت ایمنی و بهداشت و جلوگیری از سوانح و امراض برای دیگران واجرای مقررات
          ایمنی در حین انجام وظیفه است."
        />
        <Table14 argonomi={argonomi} setArgonomi={setArgonomi} reload={reload}/>
        <SpaceBetweenTables />
        <HeaderFactors
          numberFactors="عامل یازدهم"
          titelFactors="استقلال و آزادی عمل"
          maxValue="40"
          jsValue={azadiAmalScore}
        />
        <ExplainFactor
          text="این عامل اختیار ودرجه آزادی عمل شاغل در انتخاب کارها وروشها را اندازه می گیرد."
        />
        <Table15 azadiAmalScore={azadiAmalScore} setAzadiAmalScore={setAzadiAmalScore} reload={reload}/>
      </Page>
    </>
  );
};

export default PageG5;
